/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Web_Scraping_Tlm_2Inputs */

const en_svc_web_scraping_tlm_2 = /** @type {(inputs: Svc_Web_Scraping_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`captcha_policy`)
};

const ar_svc_web_scraping_tlm_2 = /** @type {(inputs: Svc_Web_Scraping_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سياسة CAPTCHA`)
};

const bn_svc_web_scraping_tlm_2 = /** @type {(inputs: Svc_Web_Scraping_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`captcha_policy`)
};

const de_svc_web_scraping_tlm_2 = /** @type {(inputs: Svc_Web_Scraping_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`captcha_policy`)
};

const es_svc_web_scraping_tlm_2 = /** @type {(inputs: Svc_Web_Scraping_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`política_captcha`)
};

const fr_svc_web_scraping_tlm_2 = /** @type {(inputs: Svc_Web_Scraping_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`captcha_policy`)
};

const pt_svc_web_scraping_tlm_2 = /** @type {(inputs: Svc_Web_Scraping_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`política_captcha`)
};

const zh_svc_web_scraping_tlm_2 = /** @type {(inputs: Svc_Web_Scraping_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`验证码策略`)
};

const tr_svc_web_scraping_tlm_2 = /** @type {(inputs: Svc_Web_Scraping_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`captcha_policy`)
};

const ru_svc_web_scraping_tlm_2 = /** @type {(inputs: Svc_Web_Scraping_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`captcha_policy`)
};

const pl_svc_web_scraping_tlm_2 = /** @type {(inputs: Svc_Web_Scraping_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`captcha_policy`)
};

/**
* | output |
* | --- |
* | "captcha_policy" |
*
* @param {Svc_Web_Scraping_Tlm_2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_web_scraping_tlm_2 = /** @type {((inputs?: Svc_Web_Scraping_Tlm_2Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Web_Scraping_Tlm_2Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_web_scraping_tlm_2(inputs)
	if (locale === "bn") return bn_svc_web_scraping_tlm_2(inputs)
	if (locale === "de") return de_svc_web_scraping_tlm_2(inputs)
	if (locale === "es") return es_svc_web_scraping_tlm_2(inputs)
	if (locale === "fr") return fr_svc_web_scraping_tlm_2(inputs)
	if (locale === "pt") return pt_svc_web_scraping_tlm_2(inputs)
	if (locale === "zh") return zh_svc_web_scraping_tlm_2(inputs)
	if (locale === "tr") return tr_svc_web_scraping_tlm_2(inputs)
	if (locale === "ru") return ru_svc_web_scraping_tlm_2(inputs)
	if (locale === "pl") return pl_svc_web_scraping_tlm_2(inputs)
	return en_svc_web_scraping_tlm_2(inputs)
});
export { svc_web_scraping_tlm_2 as "svc_web-scraping_tlm_2" }